import * as React from 'react';
import { TopTaak, MijnFnvTopTaken } from '../pages/interfaces/PageInterfaces';
import { PageHelpers } from '../pages/helpers/PageHelpers';
import { Link } from 'react-router-dom';

interface TopMenuColumn {
  label: string;
  list: TopTaak[];
}

// Topmenu
export const TopTaken = (properties: MijnFnvTopTaken) => {
  const TopTaken = properties.MijnFnvTopTaken;

  const renderColumns = PageHelpers.splitWidgetsToColumns(TopTaken);
  try {
    renderColumns[0].label = properties.TaskIntroText;
  } catch (e) {}

  // Return a block with two columns of items
  return <div className="row no-gutters">{TopMenuColumns(renderColumns)}</div>;
};

// Topmenu has two columns. This renders each column
const TopMenuColumns = (renderColumns: TopMenuColumn[]) =>
  renderColumns.map((column , index) => (
    <div key={"TopMenuColumn" + index} className="col-12 col-md-6 hero__left-col hero__toptaken">
      <div className="hero__toptaken-outer-container">
        <div className="">          
          <ul className="hero__toptaken-list">{TopMenuItemLinks(column.list)}</ul>
        </div>
      </div>
    </div>
  ));

// Topmenu has several item links. This renders each link
const TopMenuItemLinks = (items: TopTaak[]) =>
  items.map((value , index) => (
    <li key={"TopMenuItemLinks" + index} className="hero__toptaak">
      {value.ToptaakLink.indexOf("http") == 0 ?
      <a target="_blank" className="hero__toptaak-link"  href={value.ToptaakLink}>
        <span className="hero__toptaak-link-text">{value.ToptaakTitle}</span>
        <span className="icon icon-open-chevron-right" />
      </a>
      : 
      <Link className="hero__toptaak-link" to={value.ToptaakLink}>
        <span className="hero__toptaak-link-text">{value.ToptaakTitle}</span>
        <span className="icon icon-open-chevron-right" />
      </Link>
      }
    </li>
  ));
